// src/hooks/useUsers.ts
import { useQuery } from '@tanstack/react-query';
import * as api from '../api/users';

export interface User {
  id: number;
  nome: string;
}

export const useUsers = () => {
  return useQuery<User[]>({ 
    queryKey: ['users'],
    queryFn: () => api.getUsers().then(res => res.data)
  });
};
